<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('cadastro-logradouro-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'cadastro-logradouro-create'}"
                    color="primary"
                >
                    Cadastrar logradouro
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/cadastro/logradouro/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>